import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCartItems = (items) => ({
  type: actionTypes.SET_CART_ITEMS,
  payload: items
})
